<template>
<b-modal ref="poleModal" id="poleModal" :title="title" size="lg" header-bg-variant="dark" header-text-variant="light" :hide-footer="true" body-bg-variant="light" @shown="initializeModal" :no-fade="true" :static="true">
  <b-container fluid>
    <b-row no-gutters class="mb-3">
      <b-col>
        <l-map :zoom="map.zoom" :bounds="mapBounds" ref="addPoleToCircuitMap">
          <l-tile-layer :url="map.url" :attribution="map.attribution"></l-tile-layer>
          <l-image-overlay v-if="circuit.image" :url="circuit.image" :bounds="circuit.bounds"></l-image-overlay>
          <l-marker v-if="pole && pole.coordinates && pole.coordinates.latitude && isNumeric(pole.coordinates.latitude) && pole.coordinates.longitude && isNumeric(pole.coordinates.longitude)" :lat-lng="[pole.coordinates.latitude, pole.coordinates.longitude]" :title="pole.pole_substation_name" :draggable="false">
          </l-marker>
        </l-map>
      </b-col>
    </b-row>
    <b-row no-gutters class="mb-3">
      <b-col md="3"><strong>Circuit Primary:</strong></b-col>
      <b-col>{{circuit.circuit_primary}}</b-col>
    </b-row>
    <b-row no-gutters class="mb-3">
      <b-col md="3"><strong>Circuit Reference:</strong></b-col>
      <b-col>{{circuit.circuit_reference}}</b-col>
    </b-row>
    <b-row no-gutters class="mb-3">
      <b-col md="3"><strong>Circuit Name:</strong></b-col>
      <b-col>{{circuit.name}}</b-col>
    </b-row>
    <b-row no-gutters class="mb-3">
      <b-col md="3"><strong>Circuit Voltage:</strong></b-col>
      <b-col>{{this.circuit.circuit_type}}</b-col>
    </b-row>
    <b-row no-gutters class="mb-3">
      <b-col>
        <b-input-group prepend="Substation Name *">
          <b-form-input v-model="pole.pole_substation_name" type="text" />
          <div v-if="isSubstationNameInvalid && pole.pole_substation_name !== ''" class="invalid-feedback">Substation Name must be at least 3 characters long and less than 255 characters</div>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row no-gutters class="mb-3">
      <b-col>
        <b-input-group prepend="Substation Number *">
          <b-form-input v-model="pole.pole_substation_number" type="text" />
          <div v-if="isSubstationNumberInvalid && pole.pole_substation_number !== ''" class="invalid-feedback">Substation Number must be at least 3 characters long and less than 20 characters</div>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row no-gutters class="mb-3">
      <b-col>
        <b-input-group prepend="HV Pole Number *">
          <b-form-input v-model="pole.hv_pole_number" type="text" />
          <div v-if="isHVPoleNumberInvalid && pole.hv_pole_number !== '' " class="invalid-feedback">HV Pole Number must be at least 3 characters long and less than 20 characters</div>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row no-gutters class="mb-3">
      <b-col>
        <b-input-group prepend="Pole coordinates *">
          <b-form-input v-b-popover.focus.top.html="'<strong>Latitude</strong>'" v-model="pole.coordinates.latitude" @keypress.native="isNumber" type="text" placeholder="Latitude" />
          <b-form-input v-b-popover.focus.top.html="'<strong>Longitude</strong>'" v-model="pole.coordinates.longitude" @keypress.native="isNumber" type="text" placeholder="Longitude" />

          <div v-if="poleCoordinatesErrorShown" class="invalid-feedback">Pole coordinates should be within the circuit boundary</div>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row no-gutters class="mb-3">
      <b-col>
        <b-input-group prepend="Pole type">
          <b-input-group-append class="btn-group-min-width">
          <b-form-radio-group
            id="btn-radios-2"
            v-model="pole.type"
            :options="poleTypes"
            buttons
            button-variant="outline-secondary"
            name="radio-btn-outline"
            class="w-100"
            style=""
          ></b-form-radio-group>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row no-gutters class="mb-3">
      <b-col>
        <b-input-group prepend="Pole notes">
          <b-form-textarea v-model="pole.notes" type="text" rows="3" max-rows="6" />
          <div v-if="isPoleNotesInvalid" class="invalid-feedback">Pole notes must be less than 1024 characters</div>

        </b-input-group>
      </b-col>
    </b-row>
    <b-row no-gutters class="mb-3">
      <b-col>
        <div>* Required field</div>
      </b-col>
    </b-row>
    <b-row no-gutters class="mb-3">
      <b-col align-self="start" md="6">
        <b-button variant="outline-primary" @click.prevent="centerMap">Center on circuit</b-button>
      </b-col>
      <b-col class="text-right" align-self="end" md="6">
        <b-modal id="delete-pole-modal" hide-footer title="Delete Pole">
          <p class="my-4"> <b>Are You sure that You want to delete this pole?</b></p>
          <b-button class="mr-1" size="sm" variant="danger" @click="$bvModal.hide('delete-pole-modal')"> No </b-button>
          <b-button class="mr-1" size="sm" variant="success" @click="deletePole"> Yes </b-button>
        </b-modal>
        <b-button variant="dark" class="mr-1" @click.prevent="hideModal" :disabled="isDeleteDisabled" v-b-modal="'delete-pole-modal'" v-if="title === 'Edit Pole'">Delete</b-button>
        <b-button variant="danger" class="mr-1" @click.prevent="hideModal">Cancel</b-button>
        <b-button variant="success" class="save-and-close mr-1" @click="savePole(false)" :disabled="isSaveDisabled">Save</b-button>
        <b-button v-if="action=='add'"
          variant="success" class="save-and-add-new"
          @click.prevent="savePole(true)" :disabled="isSaveDisabled">Save &amp; Add Another</b-button>
      </b-col>
    </b-row>
  </b-container>
</b-modal>
</template>
<script>
import {
  latLngBounds
} from 'leaflet';
import {
  LTileLayer,
  LMap,
  LImageOverlay,
  LMarker,
} from 'vue2-leaflet';

import {
  mapActions,
  mapState
} from 'vuex';

import isNumberTextField from '@/core/isNumberTextFieldHelper';
import { circuitService } from "@/_services";
import {isEmpty} from "lodash";

export default {
  name: "PoleModal",
  components: {
    LMap,
    LTileLayer,
    LImageOverlay,
    LMarker
  },
  props: {
    action: {
      type: String,
      required: true
    },
    poleUuid: {
      type: String,
      required: false
    },
    circuit: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      map: {
        zoom: 6,
        maxZoom: 12,
        url: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      },
      pole: {
        pole_substation_name: '',
        pole_substation_number: '',
        hv_pole_number: '',
        coordinates: {
          longitude: null,
          latitude: null,
        },
        type: '',
        notes: ''
      },
      poleTypes: [
        { text: 'Single Phase', value: 'Single Phase' },
        { text: 'Three Phase', value: 'Three Phase' },
        { text: 'Voltage & Current', value: 'Voltage & Current' },
        { text: 'Undefined', value: null }
      ],
      title: 'Add Pole'
    }
  },
  methods: {
    ...mapActions('alert', ['success', 'error']),
    initializeModal: function () {
      this.resetMap();
      this.resetPole();
      if (this.action === 'edit') {
        this.title = 'Edit Pole'
        circuitService
            .getPole(this.circuit.uuid, this.poleUuid)
            .then(response => {
              this.pole = response.data
            })
            .catch(() => {
              this.error('Error reading Pole details');
            });
      } else {
        this.title = 'Add Pole'
      }
    },
    hideModal: function () {
      this.$refs.poleModal.hide();
    },
    resetMap: function () {
      this.$refs.addPoleToCircuitMap.mapObject.invalidateSize();
      this.$refs.addPoleToCircuitMap.mapObject.invalidateSize();
      this.$refs.addPoleToCircuitMap.fitBounds(this.mapBounds)
    },
    centerMap: function () {
      this.$refs.addPoleToCircuitMap.mapObject.fitBounds(latLngBounds(this.mapBounds));
    },
    isNumber: isNumberTextField,
    resetPole: function () {
      this.pole = {
        pole_substation_name: '',
        pole_substation_number: '',
        hv_pole_number: '',
        coordinates: {
          longitude: null,
          latitude: null,
        },
        notes: '',
      }
    },
    savePole: function (addNextPole) {
      const current_pole = {
        pole_substation_name: this.pole.pole_substation_name.trim(),
        pole_substation_number: this.pole.pole_substation_number.trim(),
        hv_pole_number: this.pole.hv_pole_number.trim(),
        coordinates: {
          longitude: Number(this.pole.coordinates.longitude),
          latitude: Number(this.pole.coordinates.latitude),
        },
        type: this.pole.type,
        notes: this.pole.notes,
      }
      const json_current_pole = JSON.stringify(current_pole);
      const circuit_uuid = this.circuit.uuid;
      if (this.action === 'add') {
        circuitService.addPole(circuit_uuid, json_current_pole)
            .then(() => {
              this.success("Successfully added new pole " + this.pole.pole_substation_name);
              if (addNextPole) {
                this.initializeModal();
              } else {
                this.hideModal();
              }
              this.$emit("updateCircuit", this.circuit.uuid)
            }).catch(error => {
          let errResp = error.response;
          let errorCode = errResp && errResp.status;
          let errorMessage;
          if (errorCode >= 400 && errorCode < 500) {
            errorMessage = errResp && errResp.data && errResp.data.message;
          } else {
            errorMessage = "Something has went wrong, please contact support.";
          }
          this.error(errorMessage);
        });

      } else if (this.action === 'edit') {
        circuitService.updatePole(circuit_uuid, this.poleUuid, json_current_pole)
            .then(() => {
              this.success("Successfully updated pole");
              this.$emit("updateCircuit", circuit_uuid, true)
            }).catch(() => {
          this.error("Failed update pole");
        });
      }
    },
    deletePole() {
      circuitService.deletePole(this.circuit.uuid, this.pole.uuid)
          .then(() => {
            this.success("Successfully deleted pole " + this.pole.pole_substation_name);
            this.$emit("updateCircuit", this.circuit.uuid, true)
          }).catch(error => {
        let errResp = error.response;
        let errorCode = errResp && errResp.status;
        let errorMessage;
        if (errorCode >= 400 && errorCode < 500) {
          errorMessage = errResp && errResp.data && errResp.data.message;
        } else {
          errorMessage = "Something has went wrong, please contact support.";
        }
        this.error(errorMessage);
      });
    this.$bvModal.hide("delete-pole-modal")
    }
  },
  computed: {
    ...mapState("layout", {
      hideInactiveCircuits: state => state.hideInactiveCircuits
    }),
    mapBounds() {
      if (this.circuit && this.circuit.bounds) {
        return this.circuit.bounds;
      }
      return [
        [49.6188108303, -11.0992536835],
        [59.7156195292, 2.1722306915]
      ];
    },
    isSaveDisabled() {
      return this.pole.pole_substation_name === '' || this.pole.hv_pole_number === '' || this.pole.pole_substation_number === '' ||
          this.isHVPoleNumberInvalid || this.isSubstationNumberInvalid || this.isPoleCoordinatesInvalid ||
          this.isSubstationNameInvalid || this.isPoleNotesInvalid
    },
    isDeleteDisabled() {
      return !(this.title === 'Edit Pole' && this.pole.device_serial == null)
    },
    minLatitude() {
      return Math.min(this.mapBounds[0][0], this.mapBounds[1][0]);
    },
    maxLatitude() {
      return Math.max(this.mapBounds[0][0], this.mapBounds[1][0]);
    },
    minLongitude() {
      return Math.min(this.mapBounds[0][1], this.mapBounds[1][1]);
    },
    maxLongitude() {
      return Math.max(this.mapBounds[0][1], this.mapBounds[1][1]);
    },
    isHVPoleNumberInvalid: function() {
      let pole_number_length = this.pole.hv_pole_number.trim().length
      return !(20 >= pole_number_length && pole_number_length >= 3)
    },
    isSubstationNameInvalid() {
      let substation_name_length = this.pole.pole_substation_name.trim().length
      return !(255 >= substation_name_length && substation_name_length >= 3)
    },
    isPoleNotesInvalid() {
    let pole_notes_length = this.pole.notes.trim().length
      return !(1024 > pole_notes_length)
    },
    isSubstationNumberInvalid: function() {
      let substation_number = this.pole.pole_substation_number.trim().length
      return !(20 >= substation_number && substation_number >= 3)
    },
    isPoleCoordinatesInvalid: function() {
      return (!this.pole.coordinates.latitude || !this.pole.coordinates.longitude || this.pole.coordinates.latitude==='-' 
      || this.pole.coordinates.longitude==='-' || this.pole.coordinates.latitude==='+' || this.pole.coordinates.longitude==='+'
      || parseFloat(this.pole.coordinates.latitude) > parseFloat(this.maxLatitude) || parseFloat(this.pole.coordinates.latitude) < parseFloat(this.minLatitude)
      || parseFloat(this.pole.coordinates.longitude) > parseFloat(this.maxLongitude) || parseFloat(this.pole.coordinates.longitude) < parseFloat(this.minLongitude))
    },
    poleCoordinatesErrorShown: function() {
      // This method is prevent the error message from being shown when both fields are empty (when modal loads)
      return (this.pole.coordinates.latitude === null || this.pole.coordinates.longitude === null) ? false : this.isPoleCoordinatesInvalid;
    },
  }
}
</script>
<style src="./PoleModal.scss" lang="scss" />
